
import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { Badge } from '@/components/ui/badge';
import { CreateLocalShopPriceInput } from '@/types/database/local-shop-prices';
import { formatCurrency } from '@/lib/utils';

interface LocalShopPreviewTableProps {
  data: CreateLocalShopPriceInput[];
}

const LocalShopPreviewTable: React.FC<LocalShopPreviewTableProps> = ({ data }) => {
  if (data.length === 0) {
    return (
      <div className="text-center py-8">
        <p className="text-gray-500">No data to preview</p>
      </div>
    );
  }

  return (
    <div className="border rounded-lg max-h-96 overflow-y-auto">
      <Table>
        <TableHeader className="sticky top-0 bg-white">
          <TableRow>
            <TableHead>Date</TableHead>
            <TableHead>Product Name</TableHead>
            <TableHead>Location</TableHead>
            <TableHead className="text-right">Price</TableHead>
            <TableHead>Remark</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {data.map((price, index) => (
            <TableRow key={index}>
              <TableCell>
                <Badge variant="outline">
                  {new Date(price.date).toLocaleDateString()}
                </Badge>
              </TableCell>
              <TableCell className="font-medium">{price.product_name}</TableCell>
              <TableCell>{price.location}</TableCell>
              <TableCell className="text-right font-mono">
                {formatCurrency(price.price)}
              </TableCell>
              <TableCell>
                {price.product_remark && (
                  <span className="text-sm text-gray-600 line-clamp-2">
                    {price.product_remark}
                  </span>
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default LocalShopPreviewTable;
